// Enums for Asset Dropdowns
export enum AssetDropdownOptions {
  WBTC = 'WBTC',
  WETH = 'WETH',
}
